import { graphql } from '@/gql'

export const HireFragment = graphql(/* GraphQL */ `
  fragment HireType on Hire {
    id
    purchaseOrderNumber
    worker {
      id
      name
    }
    recruiter {
      id
      name
    }
    owners {
      id
      user {
        id
        name
      }
    }
    customFieldValues {
      ...CustomFieldValuesView
      ...FieldableFormCustomFieldValue
    }
    ...HireCustomFieldSections
    job {
      id
      owners {
        id
        name
      }
      currency
      project {
        id
        name
      }
      customFieldValues {
        ...CustomFieldValuesView
      }
    }
  }
`)

export const HireJobBudgetFragment = graphql(/* GraphQL */ `
  fragment HireJobBudget on Hire {
    id
    job {
      id
      internalBudget
    }
  }
`)

export const HireJobFragment = graphql(/* GraphQL */ `
  fragment HireJobType on Job {
    id
    name
    requiredWorkers
    association
    expectedExperienceLevel
    completed
    published
    available
    isJobPost
    owners {
      id
      name
    }
    project {
      id
      name
    }
    customFieldValues @include(if: $isCompany) {
      ...CustomFieldValuesView
    }
    languages {
      name
      experience
    }
    industries {
      id
      name
    }
    skills {
      id
      name
    }
    hires {
      data {
        id
        activeContract {
          id
          workerSignature
        }
      }
    }
  }
`)
